//@ refers to the root directory.

import json from "@/assets/area-research-data.json"; //All articles in a JSON object
import lowLevelTerms from "@/assets/terms.json"; //An object mapping low level terms to mid level terms
import topics from "@/assets/topics.json"; //An object mapping mid level terms to all associated low level terms
import termsLowLevel from "@/assets/low.json";
// import { terms } from "@/assets/co-occurences";
import ClientJS from "clientjs";
var client = new ClientJS();
export let store = {
  debug: true,
  state: {
    allArticles: json, //All research data loaded as an object
    lowLevelTerm: "", //Updated whenever a search term is entered or tag is followed
    midLevelTerm: null, //Updated whenever a search term is entered or tag is followed
    showResultsTable: false, //Whether to show or hide the table component containing a list of articles
    lowLevelTerms, //Used to generate suggestions for auto suggest input field.
    filteredArticles: [], //Used by Table component to display relevant search results.
    suggestions: [], //Used to hold our auto-suggest terms.
    selectedArticle: null, //Used to hold the article that the user is currently viewing
    relatedIds: null, //Id's of articles related to the current article, if any.
    searchLevel: null, //Whether the user is searching on a low level term or is performing a mid level search by category.
    midLevelTerms: topics.map(a => a.term), //An array of all possible mid level terms.
    associatedTerms: null //Terms that may be associated with the currently selected low level term.
  },
  history: [], //Used to hold the user's search history and allows to go back to previous search
  savedHistory: [], //Same as history but entries are only added and never removed.  Intended to be used for analytics purposes.
  userInfo: {
    browser: client.getBrowser(),
    os: client.getOS(),
    device: client.getDevice(),
    searchHistory: [],
    articleHistory: [],
    email: null,
    id: null
  },

  getFilteredArticles() {
    //Filter through our primary data set and only return a list of articles that include either the selected low level or midlevel term
    this.getAssociatedTerms(store.state.lowLevelTerm); //Find lowlevel terms that are associated with the selected low/mid level term.
    //Take the current search terms and level and store them in our history.  Used for the Previous Search functionality.
    store.history.unshift({
      lowLevelTerm: store.state.lowLevelTerm,
      midLevelTerm: store.state.midLevelTerm,
      searchLevel: store.state.searchLevel
    });
    // !!!!!!!!!!!!!!! DO SOMETHING WITH INCLUDES TO MAKE IT STRICT!!!!!!!!!!!!!!!

    //Filter through our list of articles and see if either the low level or mid level term matches.
    return (this.state.filteredArticles = json
      .filter(article => {
        if (this.state.lowLevelTerm != "") {
          store.state.searchLevel = "low";
          if (article["LowLevel"].match(this.state.lowLevelTerm) != null) {
            // FIND SEARCH TERM THAT WE ARE PUTTING IN
            var searchLowLevelTerm = article["LowLevel"].match(
              this.state.lowLevelTerm
            )[0];

            // GET LOW LEVEL TERMS ON THE ARTICLE
            var LowLevelArr = article.LowLevel.split(";");
            var displayLowArticle;

            // COMPARE SEARCH TERM TO EACH LOW LEVEL TERM, IF TRUE, CONSOLE LOG - 'MATCH'
            LowLevelArr.forEach(element => {
              if (element === searchLowLevelTerm) {
                displayLowArticle = article.Title;
              }
            });

            return displayLowArticle;
          }
        } else {
          store.state.searchLevel = "mid";

          var searchMidLevelTerm = article["MidLevel"].match(
            this.state.midLevelTerm
          )[0];

          var MidLevelArr = article.MidLevel.split(";");
          var displayMidArticle;

          MidLevelArr.forEach(element => {
            if (element === searchMidLevelTerm) {
              displayMidArticle = article.Title;
            }
          });
          return displayMidArticle;

          // return article["MidLevel"].match(this.state.midLevelTerm);
        }
      })
      .sort((a, b) => a["Publication year"] < b["Publication year"])); //Sort results by Publication year key.

  },
  //Find the number of articles related to a term.  Used to display co-occurrences under results table.
  getArticleCountForTerm(term) {
    // TERM HERE IS EACH OF THE TOP 10 LOW LEVEL OCCURENCES WE GOT IN FUNCTION  getLowLevelOccurences()
    return json.filter(article => {
      if (this.state.searchLevel == "low") {
        // SO WE ARE LOOKING HOW MANY ARTICLES SHOW UP THAT MATCH THE TERMS THAT WE HAVE FOUND
        // var regex = new RegExp( "^" + term + "$", 'g' );
        return article["LowLevel"].match(term);
      }
      // } else {
      //   return article["MidLevel"].includes(term);
      // }
    }).length;
  },

  //Find low level co-occurences
  // SOFYA UPDATED THIS FUNCTION FOR MAIN ITEMS TO SHOW UP CORRECTLY
  getAssociatedTerms(term) {
    this.state.lowLevelTerm = term
    topics.filter(topic => {
      // get the low level term that is typed in === term
      // get main topic associated with that term === store.state.midLevelTerm
      // get terms associated with that topic  ===  topic.lowLevel
      if (topic.lowLevel.includes(term)) {
        return topic.lowLevel
      }
    })
  },

  //Find articles related to the currently selected article.
  getRelatedArticles() {
    this.state.relatedIds = this.state.selectedArticle["Top20AbsAndTags"];
    this.state.relatedArticles = json
      .filter(article => {
        let match = this.state.relatedIds.includes(article["Index"]);
        return match;
      })
      .sort((a, b) => a["Publication year"] < b["Publication year"]);
  },
  //Takes in an article object and sets it to the currently seelcted article.  This will cause the Single Article component to render.
  setSelectedArticle(article) {
    this.state.selectedArticle = article;
    this.state.showResultsTable = false;
    this.state.relatedIds = article["Top20AbsAndTags"];
    store.userInfo.articleHistory.push(article["Index"]);
    this.getRelatedArticles();
    window.scrollTo(0, 0)
  },

  getFilteredArticlesOld() {
    //Filter through our primary data set and only return a list of articles that include either the selected low level or midlevel term
    this.getAssociatedTerms(this.state.lowLevelTerm)//Find lowlevel terms that are associated with the selected low/mid level term.
    //Take the current search terms and level and store them in our history.  Used for the Previous Search functionality.
    store.history.unshift({ lowLevelTerm: store.state.lowLevelTerm, midLevelTerm: store.state.midLevelTerm, searchLevel: store.state.searchLevel })

    //Filter through our list of articles and see if either the low level or mid level term matches.
    return this.state.filteredArticles = json.filter((article) => {
      if (this.state.lowLevelTerm != "") {
        store.state.searchLevel = 'low'
        return article["LowLevel"].includes(this.state.lowLevelTerm)
      } else {
        store.state.searchLevel = 'mid'
        return article["MidLevel"].includes(this.state.midLevelTerm)
      }
    }).sort((a, b) => a["Publication year"] < b["Publication year"])//Sort results by Publication year key.
  },

  //Used by the CoOccurences component
  getMidlevelTermFromLowlevel(term) {
    this.state.lowLevelTerm = term;
    this.state.midLevelTerm = topics.filter(topic =>
      topic.lowLevel.includes(term)
    )[0].term;
    // THIS WOULD SEARCH THE CO-OCCURING TERMS NOT STRICTLY
    // this.getFilteredArticlesOld();
    this.getFilteredArticles();
  },
  //Used by the CoOccurences and Articles components
  update_search(item) {
    if (store.state.midLevelTerms.includes(item)) {
      store.state.midLevelTerm = item;
      store.state.lowLevelTerm = "";
      store.state.searchLevel = "mid";
    } else {
      store.state.lowLevelTerm = item;
      store.state.searchLevel = "low";
      store.history.searchLevel = "low";
    }

    store.getFilteredArticles();
  },
  //Perform the users previous search and remove it from the history.
  loadPreviousSearch() {
    store.history.shift();
    let history = store.history[0];
    store.state.lowLevelTerm = history.lowLevelTerm;
    store.state.midLevelTerm = history.midLevelTerm;
    store.state.searchLevel = history.searchLevel;
    store.getFilteredArticles();
  },
  getLowLevelOccurences() {
    let sortable = [];

    let term = termsLowLevel.find(a => {
      // LOOPING THROUGH LOW>JSON AND FINDING WHEN CATEGORY MATCHES TERM OF INPUT
      return a.category === store.state.lowLevelTerm
    });

    for (var t in term) {
      // HERE ARE ALL LOW LEVEL TERMS THAT ARE UNDER MATCHED CATEGORY ABOVE
      // AS WELL AS HOW MANY TIMES THEY SHOW UP IN LOW.JSON FILE FOR THAT CATEGORY
      sortable.push([t, term[t]]);
    }

    var sortTags = sortable.sort(function (a, b) {
      return a[1] - b[1];
    });

    // WE REVERSE THEM TO ORDER THEM BY THE NUMBER OF OCCURENCES WITH HIGHEST FIRST
    //THEN WE LIMIT THE NUMBER TO 10
    sortTags = sortTags.reverse().slice(0, 10);
    return sortTags.filter(a => a[1] != "")
  },
  // getMidLevelOccurences() {
  //   let sortable = [];
  //   let term = terms.find(a => {
  //     return a.category === store.state.midLevelTerm
  //   })

  //   for (var t in term) {
  //     sortable.push([t, term[t]]);
  //   }
  //   return sortable
  //     .sort(function (a, b) {
  //       return a[1] - b[1];
  //     })
  //     .reverse()
  //   // THIS LIMITS MID LEVEL CO OCCURENCES TO 10
  //   // .slice(0, 10);
  // },
  //This function is similiar to selectHandler() in Home.vue.  Essentially takes the chosen low/mid level terms and uses it to create a search.
  setMetaData(midLevel, lowLevel) {
    this.store.state.lowLevelTerm = lowLevel;
    this.store.state.midLevelTerm = midLevel;
    this.store.getFilteredArticles();
    this.store.state.showResultsTable = true;
    this.$router.push("/");
  }
};
